import { Navigate } from "react-router-dom";

/* ==========================
   Pages
========================== */

import NotFound from "../pages/NotFound";
import Dashboard from "../pages/dashboard/page";
import Transactions from "../pages/transactions/page";
import Notifications from "../pages/notifications/page";
import Wallet from "../pages/wallet/page";
import Rewards from "../pages/rewards/page";
import Support from "../pages/support/page";
import AddFundDashboard from "../pages/addFund/pages";
import BundleDashboard from "../pages/bundle/pages";
import AirtimeDashboard from "../pages/airtime/pages";
import ProfileDashboard from "../pages/account/page";

/* ==========================
   Auth Pages
========================== */

import LoginPage from "../authFlow/login/pages";
import Signup from "../authFlow/signup/pages";
import ForgotPassword from "../authFlow/forgot/pages";
import ResetPassword from "../authFlow/resetPassword/pages";
import VerifyCode from "../authFlow/verify/pages";

/* ==========================
   Route Guards
========================== */

import ProtectedRoute from "../route/ProtectedRoute";
import PublicRoute from "../route/PublicRoute";
import FundingSuccessPage from "../pages/addFund/component/FundingSuccessPage";
import AllDataOffersPage from "../pages/topOffers/page";
import TransactionDetails from "../pages/transactions/TransactionDetails";
import ReportTransaction from "../pages/reports/page";
import NotificationsPage from "../pages/NotificationsPage";
import ElectricityPayment from "../pages/bills/Electricity";
import CablePayment from "../pages/bills/TV";
import EpinPayment from "../pages/bills/Epin";

/* ==========================
   Routes
========================== */

const routes = [

  /* ==========================
     PUBLIC ROUTES
  ========================== */

  {
    path: "/login",
    element: (
       <PublicRoute>
        <LoginPage />
       </PublicRoute>
    ),
  },

  {
    path: "/signup",
    element: (
       <PublicRoute>
        <Signup />
     </PublicRoute>
    ),
  },

  {
    path: "/forgot-password",
    element: (
       <PublicRoute>
        <ForgotPassword />
       </PublicRoute>
    ),
  },

  {
    path: "/reset-password",
    element: (
     <PublicRoute>
        <ResetPassword />
       </PublicRoute>
    ),
  },

  {
    path: "/verify",
    element: (
       <PublicRoute>
        <VerifyCode />
       </PublicRoute>
    ),
  },

  /* ==========================
     PROTECTED ROUTES
  ========================== */

  {
    path: "/",
    element: (
     <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },


  {
    path: "/notifications",
    element: (
       <ProtectedRoute>
        <NotificationsPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard",
    element: (
       <ProtectedRoute>
        <Dashboard />
       </ProtectedRoute>
    ),
  },

  {
    path: "/report-transaction",
    element: (
       <ProtectedRoute>
        <ReportTransaction />
      </ProtectedRoute>
    ),
  },

  {
    path: "/offers",
    element: (
      <ProtectedRoute>
        <AllDataOffersPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/pay-electricity",
    element: (
      <ProtectedRoute>
        <ElectricityPayment />
      </ProtectedRoute>
    ),
  },

  {
    path: "/pay-cable",
    element: (
      <ProtectedRoute>
        <CablePayment />
      </ProtectedRoute>
    ),
  },

  {
    path: "/buy-epin",
    element: (
      <ProtectedRoute>
        <EpinPayment />
      </ProtectedRoute>
    ),
  },

  {
    path: "/transactions",
    element: (
       <ProtectedRoute>
        <Transactions />
       </ProtectedRoute>
    ),
  },

  {
    path: "/transactions/:id",
    element: (
       <ProtectedRoute>
        <TransactionDetails />
       </ProtectedRoute>
    ),
  },

  {
    path: "/account",
    element: (
       <ProtectedRoute>
        <ProfileDashboard />
       </ProtectedRoute>
    ),
  },

  {
    path: "/notifications",
    element: (
      <ProtectedRoute>
        <Notifications />
      </ProtectedRoute>
    ),
  },

  {
    path: "/rewards",
    element: (
       <ProtectedRoute>
        <Rewards />
       </ProtectedRoute>
    ),
  },

  {
    path: "/wallet",
    element: (
       <ProtectedRoute>
        <Wallet />
       </ProtectedRoute>
    ),
  },

  {
    path: "/support",
    element: (
      <ProtectedRoute>
        <Support />
      </ProtectedRoute>
    ),
  },

  {
    path: "/buy-bundle",
    element: (
       <ProtectedRoute>
        <BundleDashboard />
       </ProtectedRoute>
    ),
  },

  {
    path: "/buy-airtime",
    element: (
       <ProtectedRoute>
        <AirtimeDashboard />
      </ProtectedRoute>
    ),
  },

  {
    path: "/add-fund/*",
    element: (
       <ProtectedRoute>
        <AddFundDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/funding-success",
    element: (
       <ProtectedRoute>
        <FundingSuccessPage/>
      </ProtectedRoute>
    ),
  },

  /* ==========================
     404
  ========================== */

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;